"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useToolbarButton_unstable", {
    enumerable: true,
    get: function() {
        return useToolbarButton_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactbutton = require("@fluentui/react-button");
const useToolbarButton_unstable = (props, ref)=>{
    const { vertical = false, ...buttonProps } = props;
    const state = (0, _reactbutton.useButton_unstable)({
        appearance: 'subtle',
        ...buttonProps
    }, ref);
    return {
        vertical,
        ...state
    };
};
